[
  "enchanted_golden_apple",
  "experience_bottle",
  "written_book",
  "nether_star",
  "enchanted_book",
  "end_crystal",
  "debug_stick"
]
